// Raw CSS properties Chakra doesn't resolve tokens for: read the theme
// variables directly (light hex as fallback) so dark mode reaches them.
// Typed text: near-white in dark mode (design), secondary-700 in light.
const TEXT_FILL =
  'var(--kula-dark-secondary-900, var(--kula-colors-secondary-700, #6D659D))';
const AUTOFILL_INSET = '0 0 0px 1000px var(--kula-colors-white, #FFFFFF) inset';

const autofillStyles = {
  '&:-webkit-autofill': {
    '-webkit-text-fill-color': TEXT_FILL,
    boxShadow: AUTOFILL_INSET,
    transition: 'background-color 5000s ease-in-out 0s',
  },
  '&:-webkit-autofill:hover, &:-webkit-autofill:focus, &:-webkit-autofill:active':
    {
      '-webkit-text-fill-color': TEXT_FILL,
      boxShadow: AUTOFILL_INSET,
    },
};

export const variantOutline = () => {
  return {
    field: {
      border: '1px solid var(--kula-colors-border-color) !important',
      bg: 'white',
      _hover: {
        border: '1px solid var(--kula-colors-border-color) !important',
        boxShadow: 'none',
      },
      _active: {
        border: '1px solid var(--kula-colors-border-color) !important',
        boxShadow: 'none',
      },
      _readOnly: {
        boxShadow: 'none !important',
        userSelect: 'all',
      },
      _disabled: {
        cursor: 'not-allowed',
        backgroundColor: 'secondary-25',
        color: 'secondary-300',
        opacity: 1,
      },
      _invalid: {
        border: '1px solid var(--kula-colors-error-200) !important',
        boxShadow: 'none',
        bg: 'pastel-1-light',
        _placeholder: {
          color: 'error-100',
        },
      },
      _focus: {
        bg: 'white',
        border:
          '1px solid var(--kula-colors-secondary-300, #BFC3DF) !important',
        zIndex: 1,
        boxShadow: 'none',
      },
      _placeholder: {
        color: 'secondary-500',
      },
      style: {
        '-webkit-text-fill-color': TEXT_FILL,
      },
      ...autofillStyles,
    },
  };
};

const noBorder = () => {
  return {
    field: {
      border: 0,
      bg: 'white',
      p: '0 8px',
      _hover: {
        boxShadow: 'none',
      },
      _readOnly: {
        boxShadow: 'none !important',
        userSelect: 'all',
      },
      _disabled: {
        cursor: 'not-allowed',
        backgroundColor: 'secondary-25',
        color: 'secondary-300',
        opacity: 1,
      },
      _invalid: {
        boxShadow: 'none',
      },
      _focus: {
        boxShadow: 'none',
        zIndex: 1,
      },
      _placeholder: {
        color: 'hsl(0, 0%, 50%)',
      },
      ...autofillStyles,
    },
  };
};

const atsInputVariant1 = () => {
  return {
    field: {
      border: '1px solid',
      bg: 'secondary-50',
      p: '0 8px',
      borderColor: 'border-color',
      _hover: {
        boxShadow: 'none',
      },
      _disabled: {
        cursor: 'not-allowed',
        backgroundColor: 'secondary-25',
        color: 'secondary-300',
        opacity: 1,
      },
      _invalid: {
        boxShadow: 'none',
      },
      _focus: {
        boxShadow: 'none',
        zIndex: 1,
      },
      _placeholder: {
        color: 'red',
      },
      ...autofillStyles,
    },
  };
};

const atsInputVariant2 = () => {
  return {
    field: {
      border: '2px solid',
      borderColor: 'border-color',
      bg: 'white',
      p: '0 8px',
      _hover: {
        boxShadow: 'none',
        border: '2px solid #605AFB !important',
        borderColor: '#605AFB !important',
        outlineOffset: '0',
        outline: '4px solid #6220A30F !important',
      },
      _readOnly: {
        boxShadow: 'none !important',
        userSelect: 'all',
      },
      _disabled: {
        cursor: 'not-allowed',
        backgroundColor: 'secondary-25',
        color: 'secondary-300',
        opacity: 1,
      },
      _invalid: {
        boxShadow: 'none',
      },
      _focus: {
        boxShadow: 'none',
        outlineOffset: '0',
        borderColor: 'ats-primary',
        outline: '4px solid #6220A30F !important',
        border: '2px solid #605AFB !important',
      },
      _placeholder: {
        color: 'secondary-500',
      },
      ...autofillStyles,
    },
  };
};

export const Input = {
  baseStyle: {
    border: '1px solid',
    borderColor: 'border-color',
    _placeholder: {
      color: 'secondary-500',
    },
  },
  sizes: {
    md: {
      field: {
        fontSize: '14px',
      },
    },
  },

  variants: {
    outline: variantOutline,
    'no-border': noBorder,
    'ats-input-variant-1': atsInputVariant1,
    'ats-input-variant-2': atsInputVariant2,
  },

  defaultProps: {
    variant: 'outline',
    size: 'md',
  },
};
